import { legal } from './legalReducer';
import { pollen } from './pollenReducer';
import { appState } from './appStateReducer';
import { displayAd } from './displayAdReducer';
import { units } from './unitsReducer';
import { location } from './locationReducer';
import { favoriteLocations } from './favoriteLocationsReducer';
import { combineReducers } from 'redux';
import { dataLayer } from '@weatherbug/common';
import { nationalOutlook } from './nationalOutlookReducer';
import { snowSki } from './snowSkiReducer';
import { pageVisibility } from './pageVisibilityReducer';
import { featuredCategoriesWeatherCams } from './featuredCategoriesWeatherCamsReducer';
import { weatherCamTimeLapseControl } from './weatherCamTimeLapseControlReducer';
import { taboola } from './taboolaReducer';
import { manageLocationsPopup } from './manageLocationsPopupReducer';
import { weatherWidget } from './weatherWidgetReducer';
import { newsStoryPopup } from './storyPopupReducer';
import { lifeSubNavMenu } from './LifePageSubNavMenuReducer';
import { breakingNews } from './breakingNewsReducer';
import { sitemapLocations } from './sitemapReducer';
import { solar } from './solarReducer';
import { hourlyForecastPage } from './hourlyForecastPageViewReducer';
import { dailyForecastPage } from './dailyForecastPageViewReducer';
import { forecastPageScroll } from './forecastPageScrollReducer';
import { alertsPage } from './alertReducer';
import { userAuth } from './authReducer';
import { aqiTopTriggerHealthAdviceDetailModal } from './aqiTopTriggerHealthAdviceDetailsModalReducer';
import { statePrivacy } from './statePrivacyReducer';
import { smartAppBanner } from './smartBannerReducer';
import { mapAdRefresh } from './mapAdRefreshReducer';
import { newsStories } from './stories/storiesReducer';
import { boltive } from './boltiveReducer';
import { initialServerTrafficCamsData } from './trafficCameraReducer';

const rootReducer = combineReducers({
    legal,
    nationalOutlook,
    pollen,
    appState,
    displayAd,
    units,
    location,
    favoriteLocations,
    snowSki,
    pageVisibility,
    featuredCategoriesWeatherCams,
    weatherCamTimeLapseControl,
    taboola,
    manageLocationsPopup,
    weatherWidget,
    newsStoryPopup,
    lifeSubNavMenu,
    breakingNews,
    sitemapLocations,
    solar,
    hourlyForecastPage,
    dailyForecastPage,
    forecastPageScroll,
    alertsPage,
    userAuth,
    aqiTopTriggerHealthAdviceDetailModal,
    statePrivacy,
    smartAppBanner,
    mapAdRefresh,
    newsStories,
    boltive,
    initialServerTrafficCamsData,
    ...dataLayer.reducers
});

export default rootReducer;
